Greenmile.Survey = Greenmile.Survey || {};
Greenmile.Survey.Templates = Greenmile.Survey.Templates || {};
Greenmile.Survey.Templates.Sidebar = Greenmile.Survey.Templates.Sidebar || {};
Greenmile.Survey.Templates.Sidebar.SurveyGenericContainerTemplate = function (data) {
  const genericSurveyTemplate = {
    'items': [
      {
        'items': [
          {
            'html': Monet.I18n.getResourcesByKey('Survey.new.question.header'),
            'attributes': {
              'class': 'contentHeader',
            },
          },
          {
            'tag': 'input',
            'attributes': {
              'type': 'text',
              'id': 'QuestionDescription',
              'maxlength': '255',
            },
          },
        ],
        'attributes': {
          'class': 'SingleRowHeader',
        },
      },
      {
        'tag': 'input',
        'attributes': {
          'type': 'hidden',
          'name': 'questionType',
          'value': data.type,
        },
      },
    ],
  };

  if (!data.hideDefaultAnswer) {
    genericSurveyTemplate.items[0].items.push({
      'tag': 'span',
      'html': Monet.I18n.getResourcesByKey('Survey.question.defaultvalue'),
      'attributes': {
        'class': 'contentHeader',
        'id': 'DefaultAnswer',
      },
    });
  }

  return new Monet.UI.LayoutGenerator(genericSurveyTemplate).render();
};
